module.exports = __webpack_public_path__ + "img/mq_5.bc2fcc2f.svg";